import IconMessageContent from './icon-message-content';

export default IconMessageContent;
